<template>
  <transition name="fade">
    <div v-if="showModal" class="note-modal">
      <div class="note-modal-backdrop" @click="closeModal()"></div>

      <div class="note-modal-dialog">
        <div class="note-modal-content">
          <div class="note-modal-header">
            <h5 class="modal-title">Desvio de procedimento{{ requirementDesc ? ` para ${requirementDesc}` : '' }}</h5>
            <button type="button" class="close" @click="closeModal()">
              <span>&times;</span>
            </button>
          </div>

          <div class="note-modal-body">
            <div class="note-text-container">
              <span>Digite a justificativa do desvio de procedimento</span>
              <textarea class="form-control" rows="13" v-model="justification" :maxlength="maxLength"></textarea>
              <small class="char-counter" :class="{ 'char-counter-limit': justification.length >= maxLength }">
                {{ justification.length }}/{{ maxLength }} caracteres
              </small>
            </div>
          </div>

          <div class="note-modal-footer">
            <button class="cancel-button" @click="closeModal()" :disabled="saving">
              <i class="fas fa-times"></i> Cancelar
            </button>

            <button class="send-button" @click="saveJustification" :disabled="saving">
              <span v-if="saving"><i class="fas fa-spinner fa-pulse"></i> Salvando...</span>
              <span v-else><i class="fas fa-save"></i> Salvar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['showModal', 'requirementInfo'],
  data() {
    return {
      requirementDesc: '',
      justification: '',
      maxLength: 200,
      saving: false,
    };
  },
  mounted() {
    if (this.requirementInfo && Object.keys(this.requirementInfo).length) {
      this.requirementDesc = this.requirementInfo.tipo_solicitacao || '';
      this.justification = this.requirementInfo.procedure_deviation?.justification || '';
    }
  },
  methods: {
    closeModal(mode = 'default', data = null) {
      this.$emit('closeDeviationModal', mode, data);
    },
    async saveJustification() {
      const justification = this.justification.trim();
      if (!justification) {
        Swal.fire({
          type: 'error',
          html: '<strong>Digite a justificativa do desvio de procedimento!</strong>'
        });
        return;
      }

      if (justification.length > this.maxLength) {
        Swal.fire({
          type: 'error',
          html: `<strong>A justificativa deve ter no máximo ${this.maxLength} caracteres!</strong>`
        });
        return;
      }

      this.saving = true;
      try {
        const { data } = await axios.post('/solicitacoes/updateProcedureDeviation', {
          id: this.requirementInfo.id,
          has_deviation: true,
          justification
        });

        if (data?.status === 'success') {
          Swal.fire({
            title: "Sucesso!",
            html: '<span>Desvio de procedimento salvo com sucesso!</span>',
            type: 'success',
            confirmButtonText: "Ok"
          });
          this.closeModal('saving', { has_deviation: true, justification });
        } else {
          throw new Error('Resposta inválida ao salvar desvio de procedimento');
        }
      } catch (error) {
        console.error('Erro ao salvar desvio de procedimento: ', error);
        Swal.fire({
          title: "Erro!",
          html: '<span>Ocorreu um erro ao salvar o desvio de procedimento</span>',
          type: 'error',
          confirmButtonText: "Ok"
        });
      } finally {
        this.saving = false;
      }
    }
  },
};
</script>

<style scoped lang="scss">
.note-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.note-modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.note-modal-dialog {
  position: relative;
  z-index: 1051;
  background: white;
  border-radius: 0.3rem;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  width: 70vw;
  height: 60vh;
  max-height: 60vh;
  max-width: 100%;
  overflow: hidden;
}

.note-modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.note-modal-header,
.note-modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  font-weight: bold;
  display: flex;
  gap: 10px;

  button {
    border-radius: 7px !important;
    transition: 0.3s ease-in-out;
    border: none;
    padding: 5px 10px;
  }

  button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .send-button {
    background-color: rgb(46, 134, 46);
    color: white;

    &:hover {
      background-color: rgb(33, 95, 33);
    }
  }

  .cancel-button {
    background-color: rgb(179, 52, 52);
    color: white;

    &:hover {
      background-color: rgb(141, 42, 42);
    }
  }
}

.note-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .modal-title {
    font-weight: bold;
  }
}

.note-modal-body {
  padding: 1rem;
  display: flex;
  gap: 10px;
  flex: 1;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}

.note-text-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-height: 0;
  border: 2px solid lightgray;
  border-radius: 7px;
  padding: 10px;
  background-color: white;
  box-shadow: 1px 1px 6px 0px lightgray;

  textarea {
    resize: none;
    flex: 1;
    min-height: 0;
  }

  span {
    font-size: medium;
    font-weight: bold;
  }

  .char-counter {
    align-self: flex-end;
    color: #6c757d;
  }

  .char-counter-limit {
    color: #dc3545;
    font-weight: bold;
  }
}

.note-modal-footer {
  display: flex;
  justify-content: flex-end;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
